import { render } from "./business_continuity.html?vue&type=template&id=131a30cb&external"
import script from "./business_continuity.js?vue&type=script&lang=js&external"
export * from "./business_continuity.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__